import { createElement } from "react";
import { IconSvg, type IconSvgProps } from "@contra/icons/icons";
export const MoneyWingsIcon = (props: IconSvgProps) =>
  createElement(
    IconSvg,
    {
      ...props,
      viewBox: "0 0 64 64",
    },
    <filter
      id="money-wings_svg__j"
      width={26.82}
      height={17.275}
      x={0.09}
      y={1.758}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset />
      <feGaussianBlur stdDeviation={0.333} />
      <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
      <feColorMatrix values="0 0 0 0 0.705882 0 0 0 0 0.611765 0 0 0 0 0.105882 0 0 0 1 0" />
      <feBlend in2="shape" result="effect1_innerShadow_5294:96932" />
    </filter>,
    <filter
      id="money-wings_svg__m"
      width={16.845}
      height={7.744}
      x={-1.956}
      y={3.854}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.333}
      />
    </filter>,
    <filter
      id="money-wings_svg__o"
      width={36.586}
      height={19.416}
      x={-2.238}
      y={-3.086}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={1}
      />
    </filter>,
    <filter
      id="money-wings_svg__q"
      width={13.142}
      height={6.213}
      x={5.548}
      y={9.676}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.333}
      />
    </filter>,
    <filter
      id="money-wings_svg__s"
      width={10.365}
      height={4.604}
      x={13.13}
      y={13.061}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.333}
      />
    </filter>,
    <filter
      id="money-wings_svg__u"
      width={7.294}
      height={5.738}
      x={18.509}
      y={14.418}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.333}
      />
    </filter>,
    <filter
      id="money-wings_svg__w"
      width={15.835}
      height={5.844}
      x={0.467}
      y={3.626}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.667}
      />
    </filter>,
    <filter
      id="money-wings_svg__x"
      width={12.928}
      height={5.143}
      x={7.276}
      y={9.156}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.667}
      />
    </filter>,
    <filter
      id="money-wings_svg__L"
      width={10.116}
      height={4.464}
      x={14.366}
      y={12.461}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.667}
      />
    </filter>,
    <filter
      id="money-wings_svg__M"
      width={53.332}
      height={54.666}
      x={6.668}
      y={6.667}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset />
      <feGaussianBlur stdDeviation={0.333} />
      <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
      <feColorMatrix values="0 0 0 0 0.831373 0 0 0 0 0.843137 0 0 0 0 0.313726 0 0 0 1 0" />
      <feBlend
        in2="shape"
        mode="screen"
        result="effect1_innerShadow_5294:96932"
      />
    </filter>,
    <filter
      id="money-wings_svg__O"
      width={53.332}
      height={54.666}
      x={6.668}
      y={5.333}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset />
      <feGaussianBlur stdDeviation={0.333} />
      <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
      <feColorMatrix values="0 0 0 0 0.831373 0 0 0 0 0.843137 0 0 0 0 0.313726 0 0 0 1 0" />
      <feBlend
        in2="shape"
        mode="screen"
        result="effect1_innerShadow_5294:96932"
      />
    </filter>,
    <filter
      id="money-wings_svg__Q"
      width={53.332}
      height={54.666}
      x={6.668}
      y={4}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset />
      <feGaussianBlur stdDeviation={0.333} />
      <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
      <feColorMatrix values="0 0 0 0 0.831373 0 0 0 0 0.843137 0 0 0 0 0.313726 0 0 0 1 0" />
      <feBlend
        in2="shape"
        mode="screen"
        result="effect1_innerShadow_5294:96932"
      />
    </filter>,
    <filter
      id="money-wings_svg__S"
      width={53.332}
      height={54.666}
      x={6.668}
      y={2.667}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset />
      <feGaussianBlur stdDeviation={0.333} />
      <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
      <feColorMatrix values="0 0 0 0 0.831373 0 0 0 0 0.843137 0 0 0 0 0.313726 0 0 0 1 0" />
      <feBlend
        in2="shape"
        mode="screen"
        result="effect1_innerShadow_5294:96932"
      />
    </filter>,
    <filter
      id="money-wings_svg__U"
      width={53.332}
      height={54.666}
      x={6.668}
      y={1.333}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset />
      <feGaussianBlur stdDeviation={0.333} />
      <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
      <feColorMatrix values="0 0 0 0 0.831373 0 0 0 0 0.843137 0 0 0 0 0.313726 0 0 0 1 0" />
      <feBlend
        in2="shape"
        mode="screen"
        result="effect1_innerShadow_5294:96932"
      />
    </filter>,
    <filter
      id="money-wings_svg__W"
      width={53.332}
      height={54.666}
      x={6.668}
      y={0}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset />
      <feGaussianBlur stdDeviation={0.667} />
      <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
      <feColorMatrix values="0 0 0 0 0.501961 0 0 0 0 0.552941 0 0 0 0 0.101961 0 0 0 0.5 0" />
      <feBlend
        in2="shape"
        mode="multiply"
        result="effect1_innerShadow_5294:96932"
      />
    </filter>,
    <filter
      id="money-wings_svg__ag"
      width={19.332}
      height={25.395}
      x={42.664}
      y={35.938}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      />
      <feOffset />
      <feGaussianBlur stdDeviation={0.333} />
      <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
      <feColorMatrix values="0 0 0 0 0.705882 0 0 0 0 0.611765 0 0 0 0 0.105882 0 0 0 1 0" />
      <feBlend in2="shape" result="effect1_innerShadow_5294:96932" />
    </filter>,
    <filter
      id="money-wings_svg__aj"
      width={8.322}
      height={16.096}
      x={54.658}
      y={47.141}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.333}
      />
    </filter>,
    <filter
      id="money-wings_svg__al"
      width={20.953}
      height={34.603}
      x={44.66}
      y={28.73}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={1}
      />
    </filter>,
    <filter
      id="money-wings_svg__an"
      width={6.65}
      height={12.57}
      x={49.009}
      y={44.708}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.333}
      />
    </filter>,
    <filter
      id="money-wings_svg__ap"
      width={4.849}
      height={10.028}
      x={45.775}
      y={40.625}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.333}
      />
    </filter>,
    <filter
      id="money-wings_svg__ar"
      width={6.271}
      height={6.229}
      x={41.329}
      y={39.479}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.333}
      />
    </filter>,
    <filter
      id="money-wings_svg__at"
      width={6.046}
      height={15.797}
      x={56.385}
      y={45.083}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.667}
      />
    </filter>,
    <filter
      id="money-wings_svg__au"
      width={5.299}
      height={12.899}
      x={50.26}
      y={42.667}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.667}
      />
    </filter>,
    <filter
      id="money-wings_svg__av"
      width={4.577}
      height={10.092}
      x={46.186}
      y={39.339}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
    >
      <feFlood floodOpacity={0} result="BackgroundImageFix" />
      <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur
        result="effect1_foregroundBlur_5294:96932"
        stdDeviation={0.667}
      />
    </filter>,
    <linearGradient id="money-wings_svg__a">
      <stop offset={0} stopColor="#adf56d" />
      <stop offset={0.572} stopColor="#efffe5" />
      <stop offset={1} stopColor="#ffffef" />
    </linearGradient>,
    <linearGradient
      xlinkHref="#money-wings_svg__a"
      id="money-wings_svg__k"
      x1={5.8}
      x2={21.958}
      y1={4.726}
      y2={20.175}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient id="money-wings_svg__b">
      <stop offset={0} stopColor="#ededd9" />
      <stop offset={0.572} stopColor="#ffffd0" />
      <stop offset={1} stopColor="#ffffef" />
    </linearGradient>,
    <linearGradient
      xlinkHref="#money-wings_svg__b"
      id="money-wings_svg__g"
      x1={5.8}
      x2={21.958}
      y1={4.726}
      y2={20.175}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient id="money-wings_svg__c">
      <stop offset={0} stopColor="#289f34" />
      <stop offset={1} stopColor="#ffffef" />
    </linearGradient>,
    <linearGradient
      xlinkHref="#money-wings_svg__c"
      id="money-wings_svg__n"
      x1={8.889}
      x2={7.799}
      y1={9.872}
      y2={3.176}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient id="money-wings_svg__d">
      <stop offset={0} stopColor="#57d983" />
      <stop offset={1} stopColor="#ffffef" />
    </linearGradient>,
    <linearGradient
      xlinkHref="#money-wings_svg__d"
      id="money-wings_svg__p"
      x1={23.981}
      x2={17.497}
      y1={-1.096}
      y2={10.12}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient
      xlinkHref="#money-wings_svg__c"
      id="money-wings_svg__r"
      x1={13.962}
      x2={13.131}
      y1={14.416}
      y2={9.319}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient id="money-wings_svg__e">
      <stop offset={0} stopColor="#61e08c" />
      <stop offset={1} stopColor="#ffffef" />
    </linearGradient>,
    <linearGradient
      xlinkHref="#money-wings_svg__e"
      id="money-wings_svg__t"
      x1={18.538}
      x2={19.088}
      y1={15.839}
      y2={12.901}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient id="money-wings_svg__f">
      <stop offset={0} stopColor="#53e593" />
      <stop offset={1} stopColor="#ffffef" />
    </linearGradient>,
    <linearGradient
      xlinkHref="#money-wings_svg__f"
      id="money-wings_svg__v"
      x1={22.805}
      x2={20.628}
      y1={15.225}
      y2={15.71}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient
      id="money-wings_svg__N"
      x1={54.668}
      x2={24.001}
      y1={28}
      y2={61.333}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#00803b" />
      <stop offset={1} stopColor="#146945" />
    </linearGradient>,
    <linearGradient
      id="money-wings_svg__P"
      x1={54.668}
      x2={24.001}
      y1={26.667}
      y2={60}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#039623" />
      <stop offset={1} stopColor="#0f4324" />
    </linearGradient>,
    <linearGradient
      id="money-wings_svg__R"
      x1={54.668}
      x2={24.001}
      y1={25.333}
      y2={58.667}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#1ea908" />
      <stop offset={1} stopColor="#0e4b32" />
    </linearGradient>,
    <linearGradient
      id="money-wings_svg__T"
      x1={54.668}
      x2={24.001}
      y1={24}
      y2={57.333}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#49a700" />
      <stop offset={1} stopColor="#2f7a3b" />
    </linearGradient>,
    <linearGradient
      id="money-wings_svg__V"
      x1={54.668}
      x2={24.001}
      y1={22.667}
      y2={56}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#81cc47" />
      <stop offset={1} stopColor="#058d12" />
    </linearGradient>,
    <linearGradient
      id="money-wings_svg__Y"
      x1={49.335}
      x2={18.668}
      y1={12}
      y2={45.333}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#a0dc21" />
      <stop offset={0.229} stopColor="#bcff67" />
      <stop offset={0.636} stopColor="#7ed67d" />
      <stop offset={0.809} stopColor="#45e99a" />
      <stop offset={1} stopColor="#31cf5e" />
    </linearGradient>,
    <linearGradient
      id="money-wings_svg__Z"
      x1={46.931}
      x2={19.167}
      y1={13.496}
      y2={41.92}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#007d05" />
      <stop offset={0.177} stopColor="#7dcf14" />
      <stop offset={0.499} stopColor="#00db72" />
      <stop offset={1} stopColor="#297852" />
    </linearGradient>,
    <linearGradient
      id="money-wings_svg__aa"
      x1={42.668}
      x2={46.668}
      y1={38.665}
      y2={42.665}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#528e5f" />
      <stop offset={1} stopColor="#e1e1b3" />
    </linearGradient>,
    <linearGradient
      id="money-wings_svg__ab"
      x1={46.668}
      x2={36.92}
      y1={33.331}
      y2={38.811}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#e3686b" />
      <stop offset={0.511} stopColor="#efac36" />
      <stop offset={1} stopColor="#de6511" />
    </linearGradient>,
    <linearGradient
      id="money-wings_svg__ac"
      x1={45.334}
      x2={22.668}
      y1={36}
      y2={17.333}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#bbe0b8" />
      <stop offset={0.572} stopColor="#ffffd0" />
      <stop offset={1} stopColor="#ffffef" />
    </linearGradient>,
    <linearGradient
      id="money-wings_svg__af"
      x1={40.001}
      x2={29.117}
      y1={9.333}
      y2={36.164}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#ffe600" />
      <stop offset={0.479} stopColor="#ffa030" />
      <stop offset={1} stopColor="#ff5c00" />
    </linearGradient>,
    <linearGradient
      xlinkHref="#money-wings_svg__a"
      id="money-wings_svg__ah"
      x1={61.073}
      x2={42.117}
      y1={55.246}
      y2={43.396}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient
      xlinkHref="#money-wings_svg__b"
      id="money-wings_svg__h"
      x1={61.073}
      x2={42.117}
      y1={55.246}
      y2={43.396}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient
      xlinkHref="#money-wings_svg__c"
      id="money-wings_svg__ak"
      x1={55.324}
      x2={62.083}
      y1={53.52}
      y2={52.926}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient
      xlinkHref="#money-wings_svg__d"
      id="money-wings_svg__am"
      x1={62.233}
      x2={52.962}
      y1={36.19}
      y2={45.239}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient
      xlinkHref="#money-wings_svg__c"
      id="money-wings_svg__ao"
      x1={49.676}
      x2={54.82}
      y1={49.724}
      y2={49.271}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient
      xlinkHref="#money-wings_svg__e"
      id="money-wings_svg__aq"
      x1={47.166}
      x2={49.877}
      y1={45.639}
      y2={44.381}
      gradientUnits="userSpaceOnUse"
    />,
    <linearGradient
      xlinkHref="#money-wings_svg__f"
      id="money-wings_svg__as"
      x1={46.704}
      x2={46.771}
      y1={41.354}
      y2={43.583}
      gradientUnits="userSpaceOnUse"
    />,
    <clipPath id="money-wings_svg__i">
      <path d="M0 0h64v64H0z" />
    </clipPath>,
    <mask
      id="money-wings_svg__l"
      width={27}
      height={19}
      x={0}
      y={1}
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="url(#money-wings_svg__g)"
        d="m26.822 11.59-.863 5.738a2.003 2.003 0 0 1-3.922.196l-.164-.643a1.333 1.333 0 0 0-1.62-.963l-.702.178a8.2 8.2 0 0 1-3.781.066l-.224-.05a1.15 1.15 0 0 1-.508-1.993l.516-.446-2.395.61a6.9 6.9 0 0 1-5.234-.757 1.727 1.727 0 0 1-.051-2.938L9.07 9.82l-1.403.357a8.43 8.43 0 0 1-4.88-.219l-.177-.062A3.86 3.86 0 0 1 .15 7.204a1.93 1.93 0 0 1 1.395-2.349l10.231-2.603a16 16 0 0 1 9.264.416l.53.187a8 8 0 0 1 5.252 8.736"
      />
    </mask>,
    <mask
      id="money-wings_svg__ai"
      width={20}
      height={27}
      x={42}
      y={35}
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="url(#money-wings_svg__h)"
        d="m49.237 36.566-5.347 2.251a2.003 2.003 0 0 0 .777 3.85h.664c.736 0 1.333.597 1.333 1.333v.724c0 1.278.297 2.538.869 3.68l.102.205a1.15 1.15 0 0 0 2.058 0l.304-.609v2.471c0 1.833.728 3.59 2.024 4.886a1.727 1.727 0 0 0 2.86-.675l.45-1.349v1.448c0 1.664.492 3.291 1.415 4.676l.104.156a3.86 3.86 0 0 0 3.215 1.72 1.93 1.93 0 0 0 1.932-1.932V48.844a16 16 0 0 0-2.687-8.875l-.312-.468a8 8 0 0 0-9.76-2.935"
      />
    </mask>,
    <g clipPath="url(#money-wings_svg__i)">
      <g filter="url(#money-wings_svg__j)">
        <path
          fill="url(#money-wings_svg__k)"
          d="m26.822 11.59-.863 5.738a2.003 2.003 0 0 1-3.922.196l-.164-.643a1.333 1.333 0 0 0-1.62-.963l-.702.178a8.2 8.2 0 0 1-3.781.066l-.224-.05a1.15 1.15 0 0 1-.508-1.993l.516-.446-2.395.61a6.9 6.9 0 0 1-5.234-.757 1.727 1.727 0 0 1-.051-2.938L9.07 9.82l-1.403.357a8.43 8.43 0 0 1-4.88-.219l-.177-.062A3.86 3.86 0 0 1 .15 7.204a1.93 1.93 0 0 1 1.395-2.349l10.231-2.603a16 16 0 0 1 9.264.416l.53.187a8 8 0 0 1 5.252 8.736"
        />
      </g>
      <g mask="url(#money-wings_svg__l)">
        <g filter="url(#money-wings_svg__m)" opacity={0.6}>
          <path
            fill="url(#money-wings_svg__n)"
            d="M1.586 4.52c-.031 5.366 9.036 4.194 12.638 3.152C10.05 10.394 2.663 11.1.426 10.899l-1.714-4.327z"
          />
        </g>
        <g filter="url(#money-wings_svg__o)">
          <path
            fill="url(#money-wings_svg__p)"
            d="M26.5 14.33C26.159-2.438 7.22 3.483-.237 5.686 8.276-.507 23.69-1.583 28.392-.911l3.955 10.55z"
          />
        </g>
        <g filter="url(#money-wings_svg__q)" opacity={0.6}>
          <path
            fill="url(#money-wings_svg__r)"
            d="M8.402 10.343c-.023 4.084 6.879 3.191 9.62 2.398-3.177 2.072-8.8 2.61-10.502 2.457l-1.305-3.294z"
          />
        </g>
        <g filter="url(#money-wings_svg__s)" opacity={0.6}>
          <path
            fill="url(#money-wings_svg__t)"
            d="M15.515 13.727c-.128 2.729 5.19 1.947 7.313 1.343-2.492 1.47-6.82 1.98-8.12 1.924l-.913-2.165z"
          />
        </g>
        <g filter="url(#money-wings_svg__u)">
          <path
            fill="url(#money-wings_svg__v)"
            d="m22.425 15.085-3.25.827 3.172 3.342 2.79.236-1.495-.888z"
          />
        </g>
      </g>
      <g filter="url(#money-wings_svg__w)">
        <path
          fill="#fff"
          d="M5.209 5.125C.702 5.325 1.275 6.9 3.42 7.901c2.147 1.002 8.611-1.417 11.549-2.938-1.752-.013-6.156.001-9.761.162"
        />
      </g>
      <g filter="url(#money-wings_svg__x)">
        <path
          fill="#fff"
          d="M11.266 10.618c-3.512.157-3.065 1.383-1.393 2.164 1.673.78 6.71-1.104 9-2.29-1.365-.01-4.798.001-7.607.126"
        />
      </g>
      <g filter="url(#money-wings_svg__L)">
        <path
          fill="#fff"
          d="M17.628 13.888c-2.548.114-2.224 1.004-1.01 1.57s4.87-.801 6.53-1.662c-.99-.007-3.48.001-5.52.092"
        />
      </g>
      <g filter="url(#money-wings_svg__M)">
        <path
          fill="url(#money-wings_svg__N)"
          d="m40.001 6.667 20 20.666c-12 6-16 16.667-20 23.334-3.2 5.333-10.666 9.777-13.333 10.666l-20-20C14.668 36 20.381 28.67 25.335 20 29.6 12.533 36.89 8 40 6.666"
        />
      </g>
      <g filter="url(#money-wings_svg__O)">
        <path
          fill="url(#money-wings_svg__P)"
          d="m40.001 5.334 20 20.666c-12 6-16 16.667-20 23.334-3.2 5.333-10.666 9.777-13.333 10.666l-20-20c8-5.333 13.713-12.664 18.667-21.333C29.6 11.2 36.89 6.667 40 5.333"
        />
      </g>
      <g filter="url(#money-wings_svg__Q)">
        <path
          fill="url(#money-wings_svg__R)"
          d="m40.001 4 20 20.667c-12 6-16 16.666-20 23.333-3.2 5.333-10.666 9.778-13.333 10.667l-20-20c8-5.334 13.713-12.664 18.667-21.334C29.6 9.867 36.89 5.333 40 4"
        />
      </g>
      <g filter="url(#money-wings_svg__S)">
        <path
          fill="url(#money-wings_svg__T)"
          d="m40.001 2.667 20 20.666c-12 6-16 16.667-20 23.334-3.2 5.333-10.666 9.777-13.333 10.666l-20-20C14.668 32 20.381 24.67 25.335 16 29.6 8.533 36.89 4 40 2.666"
        />
      </g>
      <g filter="url(#money-wings_svg__U)">
        <path
          fill="url(#money-wings_svg__V)"
          d="m40.001 1.334 20 20.666c-12 6-16 16.667-20 23.334-3.2 5.333-10.666 9.777-13.333 10.666l-20-20c8-5.333 13.713-12.664 18.667-21.333C29.6 7.2 36.89 2.667 40 1.334"
        />
      </g>
      <g filter="url(#money-wings_svg__W)">
        <path
          fill="url(#money-wings_svg__Y)"
          d="m40.001 0 20 20.667c-12 6-16 16.666-20 23.333-3.2 5.333-10.666 9.778-13.333 10.667l-20-20c8-5.334 13.713-12.664 18.667-21.334C29.6 5.867 36.89 1.333 40 0"
        />
      </g>
      <path
        fill="url(#money-wings_svg__Z)"
        fillRule="evenodd"
        d="M29.53 15.665c1.57-2.835 3.689-5.147 5.72-6.897a5.334 5.334 0 0 0 7.258.849l6.115 6.544a5.33 5.33 0 0 0 .348 5.578c-5.31 4.65-8.308 10.545-10.533 14.921-.633 1.245-1.203 2.366-1.747 3.302-1.008 1.736-2.677 3.67-4.476 5.392a5.33 5.33 0 0 0-7.193.083l-7.383-7.626a5.33 5.33 0 0 0 .216-5.968c4.69-4.715 8.574-10.571 11.676-16.178M39.665 2.667 54.113 18.13l1.884 2.017q-1.245.645-2.362 1.378c-6.674 4.372-10.015 10.897-12.674 16.09-.685 1.337-1.324 2.585-1.964 3.686-2.72 4.683-9.066 9.919-11.333 10.7L12.543 36.38l-1.879-1.94a34 34 0 0 0 2.15-1.614c5.823-4.739 10.625-11.658 14.383-18.452C30.824 7.818 37.02 3.838 39.664 2.667m-15 38.667a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667M35.83 19.74a2.54 2.54 0 0 1-.112-3.593l.73-.777-1.664-2.084 1.042-.832 1.545 1.934 1.44-1.532.972.913-1.572 1.672 1.524 1.908.233-.249a2.542 2.542 0 0 1 3.705 3.481l-.733.78 1.662 2.083-1.042.832-1.543-1.933-1.437 1.53-.971-.913 1.568-1.67-1.524-1.907-.23.245a2.54 2.54 0 0 1-3.593.112m2.983-1.41-1.524-1.908-.599.638a1.208 1.208 0 0 0 1.761 1.655zm1.763.071 1.523 1.908.602-.64a1.208 1.208 0 0 0-1.761-1.655z"
        clipRule="evenodd"
      />
      <path
        fill="url(#money-wings_svg__aa)"
        d="m46.668 32.531-6 10.134v6.853l6-10.187z"
      />
      <path
        fill="url(#money-wings_svg__ab)"
        d="M46.668 39.331v-6.8l-1.333 2.252v6.83zM40.668 49.518v-6.853l1.276-2.155v6.905z"
      />
      <path
        fill="url(#money-wings_svg__ac)"
        d="m19.734 22 20.934 20.667 6-10.134L26.134 12z"
      />
      <path
        stroke="#4db878"
        strokeLinecap="round"
        strokeOpacity={0.5}
        strokeWidth={0.667}
        d="m26.192 12.529 20.057 20.057-5.65 9.544L20.16 21.952z"
      />
      <path
        fill="url(#money-wings_svg__af)"
        d="m19.734 22 20.934 20.667 1.289-2.178L21.014 20zM46.668 32.533 26.134 12l-1.475 2.305 20.675 20.48z"
      />
      <g filter="url(#money-wings_svg__ag)">
        <path
          fill="url(#money-wings_svg__ah)"
          d="m49.237 36.566-5.347 2.251a2.003 2.003 0 0 0 .777 3.85h.664c.736 0 1.333.597 1.333 1.333v.724c0 1.278.297 2.538.869 3.68l.102.205a1.15 1.15 0 0 0 2.058 0l.304-.609v2.471c0 1.833.728 3.59 2.024 4.886a1.727 1.727 0 0 0 2.86-.675l.45-1.349v1.448c0 1.664.492 3.291 1.415 4.676l.104.156a3.86 3.86 0 0 0 3.215 1.72 1.93 1.93 0 0 0 1.932-1.932V48.844a16 16 0 0 0-2.687-8.875l-.312-.468a8 8 0 0 0-9.76-2.935"
        />
      </g>
      <g mask="url(#money-wings_svg__ai)">
        <g filter="url(#money-wings_svg__aj)" opacity={0.6}>
          <path
            fill="url(#money-wings_svg__ak)"
            d="M62.311 59.279c-5.192 1.352-6.292-7.724-6.17-11.472-1.608 4.717-.472 12.05.275 14.168l4.616.594z"
          />
        </g>
        <g filter="url(#money-wings_svg__al)">
          <path
            fill="url(#money-wings_svg__am)"
            d="M46.662 37.552C62.995 33.75 61.927 53.564 61.63 61.333c3.903-9.777 1.146-24.981-.666-29.371L49.767 30.73z"
          />
        </g>
        <g filter="url(#money-wings_svg__an)" opacity={0.6}>
          <path
            fill="url(#money-wings_svg__ao)"
            d="M54.994 54.107c-3.952 1.03-4.789-5.88-4.696-8.732-1.225 3.59-.36 9.172.209 10.784l3.513.452z"
          />
        </g>
        <g filter="url(#money-wings_svg__ap)" opacity={0.6}>
          <path
            fill="url(#money-wings_svg__aq)"
            d="M49.957 48.048c-2.612.797-3.166-4.55-3.104-6.757-.81 2.779-.238 7.098.138 8.345l2.323.35z"
          />
        </g>
        <g filter="url(#money-wings_svg__ar)">
          <path
            fill="url(#money-wings_svg__as)"
            d="M46.934 41.688v3.354l-4.021-2.25-.917-2.646 1.23 1.23z"
          />
        </g>
      </g>
      <g filter="url(#money-wings_svg__at)">
        <path
          fill="#fff"
          d="M60.835 55.917c.917 4.416-.75 4.25-2.25 2.416-1.5-1.833-.75-8.694 0-11.917.444 1.695 1.517 5.967 2.25 9.5"
        />
      </g>
      <g filter="url(#money-wings_svg__au)">
        <path
          fill="#fff"
          d="M54.022 51.403c.714 3.442-.584 3.312-1.753 1.883s-.585-6.775 0-9.286c.346 1.32 1.182 4.65 1.753 7.403"
        />
      </g>
      <g filter="url(#money-wings_svg__av)">
        <path
          fill="#fff"
          d="M49.282 46.045c.518 2.497-.424 2.403-1.273 1.366s-.424-4.917 0-6.74c.252.96.858 3.375 1.273 5.374"
        />
      </g>
    </g>
  );
